module.exports = __webpack_public_path__ + "img/FR10468.7bddcf1d.svg";